"use client";

export interface IdentifyTraits {
  id: string;
  email?: string;
  username?: string;
  group_id?: string;
  group_name?: string;
  [key: string]: unknown;
}

type BetterStackArgs =
  | ["init", Record<string, unknown>?]
  | ["config", Record<string, unknown>]
  | ["user", IdentifyTraits | null]
  | ["track", string, Record<string, unknown>?];

interface BetterStackQueue {
  (...args: BetterStackArgs): void;
  q?: BetterStackArgs[];
  l?: number;
}

declare global {
  interface Window {
    betterstack?: BetterStackQueue;
  }
}

export function identify(traits: IdentifyTraits) {
  if (typeof window === "undefined") return;
  window.betterstack?.("user", traits);
}

export function clearIdentity() {
  if (typeof window === "undefined") return;
  window.betterstack?.("user", null);
}

export function track(event: string, data: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  window.betterstack?.("track", event, data);
}
